import { DASHBOARD } from "../../../../routeNames.js"
// import { changeAllTitleFunction } from "../../Dashboard/functions"
import { keysToRemove } from "../constants";

export const handleNavigateDashBoard = () => {
    // changeAllTitleFunction('Dashboard', DASHBOARD)
}

export function disablingGridLog(container) {
   const main_buttons_list = container.getElementsByTagName('button');
   setTimeout(()=>{
    for (let i = 0; i < main_buttons_list.length; i++) {
      if (main_buttons_list?.length >0 && !main_buttons_list[i].closest('.exclude-disabled')) {
        main_buttons_list[i].disabled = true;
      }

    }
   },100)
}


export const sequestrationServiceline = (serviceLine) => {
    if(!serviceLine.allowed)return
    const percent = 2;

    const safeParse = (val) => parseFloat(val) || 0;

    function safeAdd(...values) {
        return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
    }

    let total = safeAdd(
        serviceLine?.deduct,
        serviceLine?.coins,
        serviceLine?.copay
    );

    serviceLine?.adjustments?.forEach((adjustment) => {
        if (adjustment?.group_code === 'PR') {
            total = safeAdd(total, adjustment?.amount);
        }
    });

    const result = (parseFloat(serviceLine.allowed??0) - total) * (percent / 100);
    const expectedSequestration = Math.round(result * 100) / 100;

    const isValid = !(serviceLine?.adjustments || []).some(
        (adj) =>
            adj?.reason_code === '253' &&
            (String(adj?.amount)?.trim() !== '' && adj?.amount !== undefined) &&
            parseFloat(adj.amount) != parseFloat(expectedSequestration)
    );
    if(!isValid){
        console.error("error",null,"Verify the Sequestration Amount")
    }
};
export const sequestrationClaim = (claim) => {
    if(!claim.claim_allowed)return
    const percent = 2;

    const safeParse = (val) => parseFloat(val) || 0;

    function safeAdd(...values) {
        return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
    }

    let total = safeAdd(
        claim?.claim_deduct,
        claim?.claim_coins,
        claim?.claim_copay
    );

    claim?.claim_adjustments?.forEach((adjustment) => {
        if (adjustment?.group_code === 'PR') {
            total = safeAdd(total, adjustment?.amount);
        }
    });

    const result = (parseFloat(claim.claim_allowed??0) - total) * (percent / 100);
    const expectedSequestration = Math.round(result * 100) / 100;

    const isValid = !(claim?.claim_adjustments || []).some(
    (adj) =>
        adj?.reason_code === '253' &&
        (String(adj?.amount)?.trim() !== '' && adj?.amount !== undefined) &&
        parseFloat(adj.amount) != parseFloat(expectedSequestration)
    );
    if(!isValid){
        console.error("error",null,"Verify the Sequestration Amount")
    }
};

// Helper function to wait for element and focus
export function waitForElementAndFocus(fieldSelector, timeout = 5000) {
    const startTime = Date.now();
    
    // Check if element exists now
    const checkElement = () => {
        const element = document.getElementsByName(fieldSelector)[0];
        if (element) {
            element.focus();
            return true;
        }
        return false;
    };
    
    // Try immediate check
    if (checkElement()) return;
    
    // Use MutationObserver to watch for DOM changes
    const observer = new MutationObserver(() => {
        if (checkElement()) {
            observer.disconnect();
        } else if (Date.now() - startTime > timeout) {
            // Timeout reached
            observer.disconnect();
            console.warn(`Element ${fieldSelector} not found within ${timeout}ms`);
        }
    });
    
    // Observe the entire document or a specific container
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Method 2: Using Object.fromEntries() and filter (more modern)
export function filterAndRemoveKeys(data) {
  return Object.fromEntries(
    Object.entries(data).filter(([key]) => !keysToRemove.includes(key))
  );
}

export function hasQaError(data) {
  // Handle array input
  if (Array.isArray(data)) {
    return data.some(item => hasQaError(item));
  }
  
  // Handle object input
  if (data && typeof data === 'object') {
    // Check if current object has error: true
    if (data.error === true) {
      return true;
    }
    
    // Recursively check all properties
    return Object.values(data).some(value => hasQaError(value));
  }
  
  // Base case: primitive value
  return false;
}

export function getAllEditedData(data) {
  const results = [];
  
  function traverse(obj) {
    if (Array.isArray(obj)) {
      obj.forEach(item => traverse(item));
    } else if (obj && typeof obj === 'object') {
      if (obj.hasOwnProperty('edited_data')) {
        results.push(obj.edited_data);
      }
      Object.values(obj).forEach(value => traverse(value));
    }
  }
  
  traverse(data);
  return results;
}

export function allowAlphanumeric(event, allowHyphen = false) {
    const key = event.key;
    
    // Allow: Backspace, Delete, Tab, Escape, Enter, Arrow keys, Home, End
    if (
        key === 'Backspace' || key === 'Delete' || key === 'Tab' ||
        key === 'Escape' || key === 'Enter' ||
        key.startsWith('Arrow') || key === 'Home' || key === 'End'
    ) {
        return true;
    }

    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey || event.metaKey) {
        return true;
    }

    // Allow alphanumeric (A-Z, a-z, 0-9)
    let isAllowed = /^[a-zA-Z0-9]$/.test(key);

    // Conditionally allow hyphen (-)
    if (!isAllowed && allowHyphen && key === '-') {
        isAllowed = true;
    }

    if (!isAllowed) {
        event.preventDefault();
        return false;
    }

    return true;
}

// Function to allow only numbers (0-9)
export function allowNumbersOnly(event, allowHyphen = false) {
    const key = event.key;
    
    // Allow: Backspace, Delete, Tab, Escape, Enter, Arrow keys, Home, End
    if (
        key === 'Backspace' || key === 'Delete' || key === 'Tab' ||
        key === 'Escape' || key === 'Enter' ||
        key.startsWith('Arrow') || key === 'Home' || key === 'End'
    ) {
        return true;
    }

    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey || event.metaKey) {
        return true;
    }

    // Allow hyphen if flag is true
    if (allowHyphen && key === '-') {
        return true;
    }

    // Allow only digits (0–9)
    const isNumber = /^[0-9]$/.test(key);
    if (!isNumber) {
        event.preventDefault();
        return false;
    }

    return true;
}



export const generateCustomeId = (key="claim")=>{
      // Generate a unique custom_id
  return `${key}_${Date.now().toString(36)}_${Math.random().toString(36).substr(2, 5)}`;
}

 export const hasEditedTrue = (claims) => {    
    for (let i = 0; i < claims.length; i++) {
      const currentClaim = claims[i];
      
      // Check claim level edited
      if (currentClaim.edited === true) {
        return true;
      }
      
      // Check service lines
      const serviceLines = currentClaim.service_lines;
      if (serviceLines) {
        for (let j = 0; j < serviceLines.length; j++) {
          const sl = serviceLines[j];
          if (sl.edited === true) {
            return true;
          }
          
          // Check service line adjustments
          const adjustments = sl.adjustments;
          if (adjustments) {
            for (let k = 0; k < adjustments.length; k++) {
              if (adjustments[k].edited === true) {
                return true;
              }
            }
          }
        }
      }
      
      // Check claim adjustments
      const claimAdjustments = currentClaim.claim_adjustments;
      if (claimAdjustments) {
        for (let j = 0; j < claimAdjustments.length; j++) {
          if (claimAdjustments[j].edited === true) {
            return true;
          }
        }
      }
    }
        return false;
  };

// Prevent typing "+" and "-" in number input
export const preventPlusMinus = (event) => {
    if (event.key === '-' || event.key === '+') {
        event.preventDefault();
    }
};


export const processPlbAdjustments = (plbAdjustments) => {
  return plbAdjustments?.map((plb, index) => ({
    ...plb,
    // plb_index: index,
    plb_amt: plb.plb_amt == 0 
      ? parseFloat(0).toFixed(2) 
      : parseFloat(plb.plb_amt || 0).toFixed(2)
  })) || [];
};

// For even better performance with very large datasets:
export function processEditedPlbAdjustments(plb_adjustments,startPlbOrder=1) {
    const result = new Array(plb_adjustments.length);
    
    for (let i = 0; i < plb_adjustments.length; i++) {
        const plb_adjustment = plb_adjustments[i];
        let hasEdited = plb_adjustment.edited === true;
        
        
        if (hasEdited) {
            // Remove dbk_ keys and return full plb_adjustment data with updated order
            plb_adjustment.order = startPlbOrder+i;
            result[i] = plb_adjustment;
        } else {
            result[i] = { plb_adjustment_id: plb_adjustment.plb_adjustment_id, order: startPlbOrder+i };
        }
    }
    
    return result;
}